import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AppBranding from './components/AppBranding';
import SocialRegistration from './components/SocialRegistration';
import RegistrationForm from './components/RegistrationForm';
import LoginPrompt from './components/LoginPrompt';

const Register = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Create Account - ContactSync Pro</title>
        <meta name="description" content="Join ContactSync Pro to streamline your relationship management with automated birthday wishes and smart contact organization." />
        <meta name="keywords" content="contact management, birthday reminders, relationship management, signup, register" />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Main Registration Card */}
          <div className="bg-surface rounded-2xl shadow-modal border border-border p-6 lg:p-8">
            {/* App Branding */}
            <AppBranding />

            {/* Social Registration Options */}
            <SocialRegistration />

            {/* Registration Form */}
            <RegistrationForm />

            {/* Login Prompt */}
            <LoginPrompt />
          </div>

          {/* Footer */}
          <div className="text-center mt-6">
            <p className="text-xs text-text-secondary">
              By creating an account, you agree to our terms and privacy policy.
              <br />
              © {new Date()?.getFullYear()} ContactSync Pro. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;